import { Ng2StateDeclaration } from '@uirouter/angular';
import { DomainDashboardComponent } from '@client/app/pages/domain/dashboard.component';
import { ChangesHistoryComponent } from '@client/app/pages/global/changes-history/changes-history.component';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { StateService, Transition } from '@uirouter/core';

export const DOMAIN_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.dashboard',
        url: '?page_id',
        params: {
            page_id: { value: null, dynamic: true },
        },
        data: {
            anonymous_access: false,
            title: 'Acquia Web Governance - Dashboard',
            /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
            shellPath: '/domains/:domainId',
        },
        views: {
            'content@base.customer.domain': {
                component: DomainDashboardComponent,
            },
        },
    },
    {
        name: 'base.customer.domain.changesHistory',
        url: '/change-history?from&to&module&chart',
        params: {
            from: { value: null, dynamic: true },
            to: { value: null, dynamic: true },
            module: { value: null, dynamic: true },
            chart: { value: null, dynamic: true },
        },
        views: {
            'content@base.customer.domain': {
                component: ChangesHistoryComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Scan History',
            shellPath: '/domains/:domainId/change-history',
        },
        resolve: [{
            token: 'hasAccessToChangesHistory',
            deps: [
                ActiveFeatureService,
                StateService,
                Transition,
            ],
            resolveFn: (
                ng2ActiveFeatureService: ActiveFeatureService,
                $state: StateService,
                transition: Transition,
            ) => {
                if (ng2ActiveFeatureService.isFeatureActivePure('history_center_all')) {
                    return Promise.resolve(true);
                }
                return $state.go('base.customer.dashboard', transition.params());
            },
        }],
    },
];
